import { render, staticRenderFns } from "./ExportWord.vue?vue&type=template&id=43ac5527"
import script from "./ExportWord.vue?vue&type=script&lang=ts"
export * from "./ExportWord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports